import { FC, HTMLAttributes } from "react";
import { useStyles } from "./VodacomRewardCard.styles";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { ProgressBar } from "../ProgressBar";

interface IVodacomRewardCardProps {
  imageSrc?: {
    src1x: string;
    src2x: string;
    src3x: string;
  };
  titleContent: string | React.ReactNode;
  progress: number;
  progressColor: string;
}

export const VodacomRewardCard: FC<
  IVodacomRewardCardProps & HTMLAttributes<HTMLDivElement>
> = ({ imageSrc, titleContent, progress, progressColor, ...othersProps }) => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      {imageSrc && (
        <StaticImage
          src={imageSrc.src1x}
          src2x={imageSrc.src2x}
          src3x={imageSrc.src3x}
          width={60}
          className={classes.image}
        />
      )}
      <div className={classes.contentText}>
        <Typography
          variant={TypographyVariant.BodyB6Bold}
          className={classes.title}
        >
          {titleContent}
        </Typography>
        <ProgressBar
          className={classes.progressBar}
          color={progressColor}
          progress={progress}
          size="small"
          data-testid="gem-progress-bar"
        />
      </div>
    </div>
  );
};
